import { Component, inject, signal, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from '../configurator/app.configurator';
import { LayoutService } from '../../service/layout.service';
import { AuthService } from '@features/auth/services/auth.service';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { Menu } from 'primeng/menu';
import { MailsModalComponent } from "../mails-modal/mails-modal.component";
import { PROFILES } from 'src/app/core/constants/profiles.constant';

@Component({
    selector: 'app-topbar',
    imports: [
        RouterModule,
        CommonModule,
        StyleClassModule,
        AppConfigurator,
        MenuModule,
        AvatarModule,
        MailsModalComponent
    ],
    templateUrl: './app.topbar.html',
})
export class AppTopbar {
    @ViewChild('userMenu') userMenu!: Menu;
    @ViewChild('mobileMenu') mobileMenu!: Menu;

    items!: MenuItem[];
    userMenuItems: MenuItem[] = [];
    private authService = inject(AuthService);
    showModalPermissions = signal<boolean>(false);

    constructor(public layoutService: LayoutService) {
        this.initializeUserMenu();
    }

    private initializeUserMenu() {

        const baseItems: MenuItem[] = [
            {
                label: 'Cerrar Sesión',
                icon: 'pi pi-sign-out',
                command: () => this.logout(),
            }
        ];

        if (this.authService.user()?.profile_id === PROFILES.ADMIN) {
            baseItems.unshift({ // unshift lo pone al principio, push al final
                label: 'Configurar Correos',
                icon: 'pi pi-envelope',
                command: () => this.showModalPermissions.set(true),
            });
        }



        this.userMenuItems = baseItems;
    }


    get user() {
        return this.authService.user();
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }

    logout() {
        this.authService.logout();
    }
}
